import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import MenuItem from '@material-ui/core/MenuItem';

import FlexInputContainer from '../../../../common/styled/FlexInputContainer/FlexInputContainer';
import CustomInput, { Props as CustomInputProps } from '../../../../components/CustomInput/CustomInput';
import Deviation from '../../../../types/Deviation';

interface Props {
    baseInputProps: Omit<CustomInputProps, 'name'>;
    getDeviationDescription: (deviation: Deviation) => string;
}

const Form = (props: Props) => {
    const { baseInputProps, getDeviationDescription } = props;
    const { data } = baseInputProps;

    const { t } = useTranslation();

    const category = useMemo(() => {
        if (data && data.deviation) {
            return t('models.deviation.enum.category.' + data.deviation.category);
        }

        return '';
    }, [data, t]);

    const description = useMemo(() => {
        const { deviation } = data;
        if (deviation) {
            return getDeviationDescription(deviation);
        }

        return '';
    }, [data, getDeviationDescription]);

    return (
        <>
            <CustomInput
                {...baseInputProps}
                name='deviationCategory'
                value={category}
                InputProps={{ readOnly: true }}
            />

            <CustomInput
                {...baseInputProps}
                name='deviationDescription'
                value={description}
                multiline
                InputProps={{ readOnly: true }}
            />

            <FlexInputContainer>
                <CustomInput {...baseInputProps} name='deviationPresent' select booleanValues>
                    <MenuItem value={'1'} >
                        {t('dialogs.generic.flag_yes')}
                    </MenuItem>
                    <MenuItem value={'0'} >
                        {t('dialogs.generic.flag_no')}
                    </MenuItem>
                </CustomInput>

                <CustomInput
                    {...baseInputProps}
                    name='deviationCount'
                    disabled={data.deviationPresent === false || data.deviationPresent === '0'}
                    type='number'
                    inputProps={{ min: 0 }}
                />

            </FlexInputContainer>

            <CustomInput {...baseInputProps} name='deviationNote' rows={3} multiline />

            <CustomInput {...baseInputProps} name='deviationResolutionDate' inputProps={{ maxLength: 10 }} />
        </>
    );
};

export default Form;
